import { 
  watchLoadCompanyFields,
  watchLoadEnterpriseFields,
  watchLoadEnterpriseGroups,
  // watchLoadSudoSiteId,
  watchLoadEnterpriseAssociations,
  watchLoadCompanyAssets,
  watchLoadSiteAssets,
  watchLoadCompanyAssetLogs,
  watchLoadCompanyAssetLogView,
  watchLoadCompanyAssociatedEnterprises,
  watchLoadCompanyUnassociatedEnterprises,
  watchLoadCompanyCreateEnterprise,
  watchLoadCompanyDeletedEnterprises,
 } from "./serviceDesk";
import { watchLoadPinMaps } from "../serviceDesk/pinMaps";

import { all } from "redux-saga/effects";

export function* rootSaga() {
  yield all(
    [
      watchLoadCompanyFields(),
      watchLoadEnterpriseFields(),
      watchLoadEnterpriseGroups(),
      // watchLoadSudoSiteId(),
      watchLoadPinMaps(),
      watchLoadEnterpriseAssociations(),
      watchLoadCompanyAssets(),
      watchLoadSiteAssets(),
      watchLoadCompanyAssetLogs(),
      watchLoadCompanyAssetLogView(),
      watchLoadCompanyAssociatedEnterprises(),
      watchLoadCompanyUnassociatedEnterprises(),
      watchLoadCompanyDeletedEnterprises(),
      watchLoadCompanyCreateEnterprise(),
    ],
  );
}